import Icon from '@components/Icon/Icon';
import cn from 'classnames';
import { Sort } from '@models';
import { IconSortASC, IconSortDESC } from '@icons';

interface TableSortIconProps {
    isActive: boolean;
    direction: Sort;
    className?: string;
}

const TableSortIcon: React.FC<TableSortIconProps> = ({
    isActive,
    direction,
    className,
}) => {
    return (
        <div className={cn(
            'TableSortIcon',
            isActive && 'is-active',
            className,
        )}>
            <div>
                <Icon type="small">
                    {direction === Sort.Asc ?  <IconSortASC />  :  <IconSortDESC />}
                </Icon>
            </div>
        </div>
    );
};

export default TableSortIcon;
